const baseUrl = process.env.REACT_APP_BASE_URL;

const Config = {
  getUserProfile: `${baseUrl}/api/v1/user/profile`,
  loginAndSignup: {
    login: `${baseUrl}/api/v1/auth/login`,
  },
  userPermissions: `${baseUrl}/api/v1/role-permission/get-permissions`,
  leadList:`${baseUrl}/api/v1/partner/lead-listing`,
  applicationList:`${baseUrl}/api/applications`,
  applicationDetails:`${baseUrl}/api/application-details`,
  componentDetails:`${baseUrl}/api/application-component-details`,
  partnerDetails:`${baseUrl}/api/partner-details`,
  documentList:`${baseUrl}/api/document-type-list`,
  documentEdit: `${baseUrl}/api/edit-document-type`,
  dmsMapping:`${baseUrl}/api/document-dms-mapping`,
  addPartner:`${baseUrl}/api/add-partner`,
  editPartner:`${baseUrl}/api/edit-partner`,
  addDms:`${baseUrl}/api/insert-dms-map`,
  editDms:`${baseUrl}/api/edit-dms-mapping`,
  addDocumentCode:`${baseUrl}/api/insert-document-code`,
  breRejectedList: `${baseUrl}/api/bre-list`,
  partnerHistory: `${baseUrl}/api/partner-history`,
  esignList: `${baseUrl}/api/esign-list`,
  queueProductVerification: `${baseUrl}/api/queue-product-verification`,
  downloadLeadList: `${baseUrl}/api/download-leadlist`,
  finTechType: `${baseUrl}/api/get-fintype-list`,
  paymentLog: `${baseUrl}/api/payment-logs`,
  dashboard: `${baseUrl}/api/dashboard`,
  finTypes: `${baseUrl}/api/get-fintypes`,
  insertFinType: `${baseUrl}/api/addfintypes`,
  finTypeHistory: `${baseUrl}/api/fintype-history`,
  getLanNo: `${baseUrl}/api/get-lannumbers`,
  getPartnerFullList: `${baseUrl}/api/get-partnerfulllist`,
  getUtrFromLan: `${baseUrl}/api/get-utrfromlan`,
  utrOperation: `${baseUrl}/api/utr-operations`,
  utrHistory: `${baseUrl}/api/utr-history`,
  resetNotificaiton: `${baseUrl}/api/reset-notification`,
};

export default Config;
